import jwtDecode from "jwt-decode";
import getUserManager from "./userManager";
import signIn from "./signIn";
/**
 * Get the expiry of the token
 */ var getTokenExpiry = function(token) {
    var exp = jwtDecode(token).exp;
    return exp;
};
/**
 * Checks if the token is expired
 */ var isTokenExpired = function(user) {
    var token = user.id_token;
    var exp = getTokenExpiry(token);
    // Check if current timestamp has exceeded exp timestamp
    var currentDateInSeconds = Math.floor(Date.now() / 1000);
    return currentDateInSeconds >= exp;
};
/**
 * Get the user
 * If the token has expired or user doesn't exists, then sign in the user
 */ var getUser = function() {
    return getUserManager().then(function(userManager) {
        return userManager.getUser();
    }).then(function(user) {
        if (user && !isTokenExpired(user)) {
            return user;
        }
        return signIn();
    });
};
export default getUser;

//# sourceMappingURL=getUser.js.map